import React from 'react';
import { FormGroup } from 'reactstrap';
import { RebelColors } from '../../../../styles/rebel-experiences';
import { transportationOptions } from '../../../../utils/budget-tool-specific';
import Select from "react-select";
import styled from 'styled-components';

const RebelFormInputExperienceMulti = (props) => {

    const handleMultiChange = (selected) => {

        console.log(selected);

        let newData = {...props.data};
        let array =[];
        Object.entries(selected).map((element) => {
            array.push(element[1].label);
            return 1;
        });
        newData[props.id].value = array;
        props.setData(newData);
    };

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            backgroundColor: '#3b3f45',
            borderColor: state.isFocused ? RebelColors.gold : RebelColors.border,
            minHeight: '46px',
            boxShadow: state.isFocused ? `0 0 0 3px rgba(255, 215, 0, 0.1)` : 'none',
            '&:hover': {
                borderColor: RebelColors.borderLight
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: '#2d2d2d',
            border: `1px solid ${RebelColors.border}`,
            borderRadius: '6px'
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? '#3b3f45'
                : state.isFocused
                    ? '#3b3f45'
                    : '#2d2d2d',
            color: RebelColors.primary,
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#3b3f45'
            }
        }),
        multiValue: (provided) => ({
            ...provided,
            backgroundColor: RebelColors.gold,
            borderRadius: '4px'
        }),
        multiValueLabel: (provided) => ({
            ...provided,
            color: '#000000',
            fontWeight: 500
        }),
        multiValueRemove: (provided) => ({
            ...provided,
            color: '#000000',
            '&:hover': {
                backgroundColor: '#d4af37',
                color: '#000000'
            }
        }),
        placeholder: (provided) => ({
            ...provided,
            color: RebelColors.primaryMuted
        }),
        input: (provided) => ({
            ...provided,
            color: RebelColors.primary
        }),
        singleValue: (provided, state) => {
            const opacity = state.isDisabled ? 0.5 : 1;
            const transition = 'opacity 300ms';

            return { ...provided, opacity, transition, color: RebelColors.primary };
        }
    }

    const defaultTransportationOptions = Object.entries(props.transportation.value).map((element, i) => {
        return ({value: i, label: element[1]});
    })

    return (
        <React.Fragment>
            <FormGroup>
                <RebelLabel for={props.id}>{props.title}</RebelLabel>
                <Select
                    placeholder="Select..."
                    isMulti
                    name="colors"
                    options={props.options}
                    defaultValue={defaultTransportationOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={e => handleMultiChange(e)}
                    styles={customStyles}
                />
            </FormGroup>

        </React.Fragment>
    )

}

export default RebelFormInputExperienceMulti;

const RebelLabel = styled.label`
    color: ${RebelColors.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 0.95rem;
    display: block;
`;
